import React from 'react';
const LanguagePickerList = (channelObj) => {
    return (
        <div className="language-picker__table-items">
            {channelObj.channels && channelObj.channels.map((data, index) => {
                return (
                    <div
                        className={`language-picker__table-item${data.buyDisabled ? ' global' : ''
                            }`}
                        key={`item${data}${index}`}
                    >
                        <a
                            href={data.url}
                            title={data.name}
                            className={`language-picker--link ${(index === 0 && channelObj.showSelected) ? 'is-current-website' : ''
                                }`}
                            key={`link${index}`}
                            onClick={() => closePopup()}
                        >
                            {data.name} | {data.englishName}
                        </a>
                    </div>
                );
            })}
        </div>
    )
}

export default LanguagePickerList;
